module.exports = __webpack_public_path__ + "static/img/323.dd6cf70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/323.png
// module id = S8Nf
// module chunks = 0